
export interface ApiPaginationMetadata {
  per_page: number;
  next_cursor: string | null;
  prev_cursor: string | null;
  total?: number;
}

export class PaginationMetadata {
  perPage: number;
  nextCursor: string | null;
  prevCursor: string | null;
  total?: number;

  constructor(data: ApiPaginationMetadata) {
    this.perPage = data.per_page;
    this.nextCursor = data.next_cursor;
    this.prevCursor = data.prev_cursor;
    this.total = data.total;
  }
}

export class ApiPaginationParams {
  per_page?: number;
  cursor?: string | null;
  total?: number;
}

export class ApiSortParams<TField extends string = string> {
  field?: TField;
  direction?: 'asc' | 'desc';
}

export class ApiListingRequestBody<TField extends string = string> {
  per_page?: number;
  cursor?: string | null;
  sort?: ApiSortParams<TField>;
}

export interface ApiUploadDetails {
  key: string;
  name: string;
}
